import React, { useEffect, useMemo, useState } from 'react';
import { withLayout } from "../../DashboardPage";
import HeaderDashboardLayout from "../../../../components/layouts/headerDashboardLayout/HeaderDashboardLayout";
import StickerWithTabButton, { TabOption } from "@elements/stickerWithTabButton/StickerWithTabButton";
import ProcessByCrops from "@pages/dashboard/works/byDepartmentsAndCrops/components/processByCrops/ProcessByCrops";
import ProcessByDepartment
    from "@pages/dashboard/works/byDepartmentsAndCrops/components/processByDepartment/ProcessByDepartment";
import WorksLegend from "@pages/dashboard/works/components/WorksLegend/WorksLegend";
import st from './styles.module.scss';
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../../store";
import { identity } from "fp-ts";
import { WorksByDepartmentsAndCropsState } from "../../../../store/reducers/dashboard/works/byDepartmentsAndCrops";
import { stickerLoadingWithCrop } from "@pages/dashboard/phases";
import { getWorkDetailsRequestParams } from "@pages/dashboard/works/detalization/utils/getWorkDetailsRequestParams";
import { useTypedSelector } from "@hooks/useTypedSelector";
import EmptyPage from "@pages/dashboard/works/byDepartmentsAndCrops/components/emptyPage/EmptyPage";
import useDashboardPageSize, { PageSize } from "@hooks/useDashboardPageSize";
import { PlanFactTree } from "@baseTypes/service/dashboard/IWorksDashboardService";

type Variants = 'departments' | 'crops'

const options: TabOption[] = [
    {
        id: 'departments',
        label: 'Подразделения'
    },
    {
        id: 'crops',
        label: 'Культуры'
    }
]

const barsSize: Record<PageSize, number> = {
    default: 500,
    middle: 264,
    small: 196
}

const worksByDepartmentsAndCropsSelector =
    createSelector((state: RootState) => state.worksByDepartmentsAndCrops, identity.of<WorksByDepartmentsAndCropsState>)

const WorksByDepartmentsAndCropsPage = () => {
    const [selectedTab, setSelectedTab] = useState<Variants>('departments')

    const {
        isApiLoading,
        data,
        apiError
    } = useTypedSelector(state => state.worksByDepartmentsAndCrops)
    const [openedGroups, setOpenedGroups] = useState<number[]>([])

    const initialOpenedGroups = useMemo(() => {
        const loop = (tree: PlanFactTree[], dfsLevel: number, acc: number[]): number[] => {
            if (dfsLevel >= 2) {
                return acc
            } else if (tree.length > 0) {
                const h = tree.shift()!
                return loop(h.children ? h.children.concat(tree) : tree, dfsLevel + 1, acc.concat(h.value.groupId))
            } else {
                return acc
            }
        }
        return loop(data.progressByDepartment ? [data.progressByDepartment] : [], 0, [])
    }, [data.progressByDepartment])

    useEffect(() => {
        setOpenedGroups(initialOpenedGroups)
    }, [initialOpenedGroups]);


    const dashboardSize = useDashboardPageSize()

    return (
        <HeaderDashboardLayout
            title={data.displayName || ''}
            cropVisible={false}
        >
            <StickerWithTabButton
                ErrorPage={EmptyPage}
                loading={isApiLoading}
                error={Boolean(apiError)}
                options={options}
                selectedId={selectedTab}
                setSelectedId={setSelectedTab as (id: string) => void}
                stickerProps={{ height: 770 }}
                tabButtonProps={{ height: 32, width: 270 }}
                title={'Ход работы'}
            >
                <div className={st['content']}>
                    {selectedTab === 'crops'
                        ? <ProcessByCrops data={data.progressByCrop} barsSize={barsSize[dashboardSize]}/>
                        : <ProcessByDepartment data={data.progressByDepartment}
                                               barsSize={barsSize[dashboardSize]}
                                               openedGroups={openedGroups}
                                               setOpenedGroups={setOpenedGroups}/>
                    }
                </div>
                <WorksLegend className={st['legend']} remain={data.total.fact} total={data.total.plan}/>
            </StickerWithTabButton>
        </HeaderDashboardLayout>
    )
}

export default withLayout(stickerLoadingWithCrop(
    worksByDepartmentsAndCropsSelector,
    actions =>
        (p, params) =>
            actions.fetchWorksByDepartmentsAndCrops(getWorkDetailsRequestParams(p, params)),
    { cropEnabled: false, preventStickerBox: true }
)(WorksByDepartmentsAndCropsPage));
